/**
 * App-level programmatic navigation.
 *
 * InsightApp uses its own `currentPath` state (driven by
 * `window.history.pushState + popstate`) rather than React Router's
 * `<Routes>`. Calling React Router's `navigate()` updates the URL via
 * pushState but does NOT fire `popstate`, so the app never re-renders the
 * new page.
 *
 * This helper:
 *   1. Calls `window.history.pushState` to update the browser URL (including
 *      any query string).
 *   2. Dispatches a synthetic `popstate` event so that:
 *      - InsightApp's handler fires → `setCurrentPath` → correct page
 *        component is rendered.
 *      - React Router's history listener fires → internal location updates →
 *        `useSearchParams` / `useLocation` hooks see the new URL.
 */
export function appNavigate(url: string): void {
  window.history.pushState({}, '', url);
  window.dispatchEvent(new PopStateEvent('popstate'));
}
